import { Particle } from "@pixi/particle-emitter";
import { behaviors } from "@pixi/particle-emitter";
import { Point } from "pixi.js";

type IEmitterBehavior = behaviors.IEmitterBehavior;

export class RotateToPointBehaviour implements IEmitterBehavior {
    public static type = "rotationToPoint";
    public order = behaviors.BehaviorOrder.Normal;
    private readonly target: Point;

    public constructor(config: {
            target: Point
    }) 
    {
        this.target = config.target;
    }

    public initParticles(first: Particle): void {
        let next = first;
        while (next)
        {
            next.rotation = this.angle(this.target, next.position);
            next = next.next;
        }
    }

    private angle(target: Point, start: Point): number {
        return Math.atan2(target.y - start.y, target.x - start.x);
    }

}